import $ from 'jquery';
import { currentLanguage, $elementRichHighlight, $elementFlyIn, $elementIncrementor } from './variables';
// import './extension';

export function checkAndRunAnimations() {
  // flyIn animations
  if ($elementFlyIn.length !== 0) {
    $elementFlyIn.each(function () {
      if ($(this).is(':visible')) {

        let fly_in_type = $(this).data('fly-in');
        let fly_in_class = "fly-in-" + fly_in_type;

        if ($(this).isInViewport(0, 0)) {
          $(this).removeClass('opacity-0');
          $(this).addClass(fly_in_class);
        }
      }
    });
  }

  // incrementor animation 
  if ($elementIncrementor.length !== 0) {

    $elementIncrementor.each(function () {

      if ($(this).is(':visible')) {
        let number = $(this).data('incrementor');
        let is_completed = $(this).data('incrementor-completed');
        let seperator = $(this).data('seperator');
        let number_container = $('.js__incrementor_num', this);

        if ($(this).isInViewport(0, 0)) {
          if (!is_completed) {
            number_container.prop('Counter', 0).animate({
              Counter: number
            }, {
              duration: 1500,
              easing: 'swing',
              progress: function (animation, progress, msRemaining) {
                if (progress === 1 && msRemaining <= 0) {
                  if (seperator) {
                    number_container.text(number.toLocaleString(currentLanguage).replace('.', seperator));
                  } else {
                    number_container.text(number.toLocaleString(currentLanguage));
                  }
                } else {
                  if (seperator) {
                    //@ts-ignore
                    number_container.text((Math.ceil(this.Counter * 100) / 100).toLocaleString(currentLanguage).replace('.', seperator));
                  } else {
                    //@ts-ignore
                    number_container.text((Math.ceil(this.Counter * 100) / 100).toLocaleString(currentLanguage));
                  }
                }
              },
              complete: function () {
                $(this).parent().data('incrementor-completed', "true");
                $(this).stop();
              }
            });
          }
        }
      }
    });
  }

  // rich highlight animation 
  if ($elementRichHighlight.length) {
    $elementRichHighlight.each(function () {

      if ($(this).is(':visible')) {
        if ($(this).isInViewport(200, 400)) {
          $('body').css('background-color', '#0f1d29');
          $('h1, h2, h3, h4, h5, div, span, p').css('color', 'white');

        } else {
          $('body').css('background-color', '');
          $('h1, h2, h3, h4, h5, div, span, p').css('color', '');
        }
      }
    })
  }
}
